"use client";

import { useMemo } from "react";

import { useRequestMeRelatedAccounts } from "../requests/useRequestMeRelatedAccounts";

export const useKidProfiles = () => {
  const { data } = useRequestMeRelatedAccounts();
  return useMemo(() => data?.filter((account) => account.is_kid), [data]);
};
